import { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { onAuthStateChanged } from 'firebase/auth';
import { clearCurrentUserData } from './common/webStorage';
import { primaryAuth } from './firebase';
import { clearDoorCache, clearPortalAblyClient } from './service/clientCache';
import Home from './view/home';
import SignIn from './view/signIn';
import './App.scss';

export default function App() {
  const [currentUser, setCurrentUser] = useState(undefined);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(primaryAuth, (user) => {
      // SESSION CLEANUP: runs on manual sign-out and forced token revocation
      if (!user) {
        clearCurrentUserData(false); // clear sessionStorage
        clearDoorCache();
        clearPortalAblyClient();
      }
      setCurrentUser(user); // conditional routing with React Router
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="app">
      <ConfigProvider theme={{ token: { fontFamily: 'IBM Plex Sans' } }}>
        <Routes>
          <Route
            path="*" // user should stay in `/home` subdir
            element={
              currentUser !== null ? (
                <Navigate to="/home" />
              ) : (
                <Navigate to="/signIn" />
              )
            }
          />
          <Route
            path="/home/*"
            element={
              currentUser !== null ? <Home /> : <Navigate to="/signIn" />
            }
          />
          <Route path="/signIn" element={<SignIn />} />
        </Routes>
      </ConfigProvider>
    </div>
  );
}
